import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { AuthTokenService } from '@core/authentication/auth-token.service';

@Injectable()
export class NotAllowLicenseDisabledPoliciesGuardService implements CanActivate {
    constructor(
        private authToken: AuthTokenService,
        private router: Router,
    ) { }

    public canActivate(): boolean {
        if (this.authToken.enabledPoliciesLicense) { return true; }

        this.router.navigate(['page-forbidden']);

        return false;
    }
}
